// extracted by mini-css-extract-plugin
export default {"RecipesStack":"sIZFRh","recipesStack":"sIZFRh"};